function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import epoch from '../lib/epoch.js';
import isObject from '../lib/is_object.js';
import secs from '../lib/secs.js';
function validateInput(label, input) {
  if (!Number.isFinite(input)) {
    throw new TypeError("Invalid ".concat(label, " input"));
  }
  return input;
}
export var ProduceJWT = /*#__PURE__*/function () {
  function ProduceJWT() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ProduceJWT);
    if (!isObject(payload)) {
      throw new TypeError('JWT Claims Set MUST be an object');
    }
    this._payload = payload;
  }
  return _createClass(ProduceJWT, [{
    key: "setIssuer",
    value: function setIssuer(issuer) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        iss: issuer
      });
      return this;
    }
  }, {
    key: "setSubject",
    value: function setSubject(subject) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        sub: subject
      });
      return this;
    }
  }, {
    key: "setAudience",
    value: function setAudience(audience) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        aud: audience
      });
      return this;
    }
  }, {
    key: "setJti",
    value: function setJti(jwtId) {
      this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
        jti: jwtId
      });
      return this;
    }
  }, {
    key: "setNotBefore",
    value: function setNotBefore(input) {
      if (typeof input === 'number') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          nbf: validateInput('setNotBefore', input)
        });
      } else if (input instanceof Date) {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          nbf: validateInput('setNotBefore', epoch(input))
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          nbf: epoch(new Date()) + secs(input)
        });
      }
      return this;
    }
  }, {
    key: "setExpirationTime",
    value: function setExpirationTime(input) {
      if (typeof input === 'number') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          exp: validateInput('setExpirationTime', input)
        });
      } else if (input instanceof Date) {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          exp: validateInput('setExpirationTime', epoch(input))
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          exp: epoch(new Date()) + secs(input)
        });
      }
      return this;
    }
  }, {
    key: "setIssuedAt",
    value: function setIssuedAt(input) {
      if (typeof input === 'undefined') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: epoch(new Date())
        });
      } else if (input instanceof Date) {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: validateInput('setIssuedAt', epoch(input))
        });
      } else if (typeof input === 'string') {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: validateInput('setIssuedAt', epoch(new Date()) + secs(input))
        });
      } else {
        this._payload = _objectSpread(_objectSpread({}, this._payload), {}, {
          iat: validateInput('setIssuedAt', input)
        });
      }
      return this;
    }
  }]);
}();